/*jshint esversion: 8 */
import { fetchPost } from './RequestHandler';

// 查询房源
const getRooms = async (data) => {
  const rst = await fetchPost('/web_room/getRooms', { data });
  return rst;
};

// 新增房源
const addRoom = async (data) => {
  const rst = await fetchPost('/web_room/addRoom', { data });
  return rst;
};

// Excel导入房源
const addRoomsFromExcel = async (data) => {
  const rst = await fetchPost('/web_room/addRoomsFromExcel', { data });
  return rst;
};

// 修改房源
const updateRoom = async (data) => {
  const rst = await fetchPost('/web_room/updateRoom', { data });
  return rst;
};

// 删除房源
const deleteRoom = async (data) => {
  const rst = await fetchPost('/web_room/deleteRoom', { data });
  return rst;
};
// 删除选中的房源
const deleteSelectedRoom = async (data) => {
  const rst = await fetchPost('/web_room/deleteSelectedRoom', { data });
  return rst;
};

// 发布房源
const publishRoom = async (data) => {
  const rst = await fetchPost('/web_room/publishRoom', { data });
  return rst;
};
// 发布选中的房源
const publishSelectedRoom = async (data) => {
  const rst = await fetchPost('/web_room/publishSelectedRoom', { data });
  return rst;
};


// 撤回房源
const recallRoom = async (data) => {
  const rst = await fetchPost('/web_room/recallRoom', { data });
  return rst;
};

// 撤回选中的房源
const recallSelectedRoom = async (data) => {
  const rst = await fetchPost('/web_room/recallSelectedRoom', { data });
  return rst;
};


export {
  getRooms,
  addRoom,
  addRoomsFromExcel,
  updateRoom,
  publishRoom,
  publishSelectedRoom,
  recallRoom,
  recallSelectedRoom,
  deleteRoom,
  deleteSelectedRoom
};
